import { FC, useState, useEffect } from "react";
import { useStyles } from "./EmailContentHistory.style";
import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";

interface EmailHistoryRecord {
  remark: string;
  createdDate: string;
}

interface IProps {
  userId: number | null;
}

const EmailContentHistory: FC<IProps> = ({ userId }) => {
  const { classes } = useStyles();
  const [emailHistory, setEmailHistory] = useState<EmailHistoryRecord[]>([]);

  const formatDate = (dateString: string): string => {
    try {
      if (!dateString) return "No date available";

      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }

      const formatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kuala_Lumpur",
      });

      const formatted = formatter.format(date);
      const [datePart, timePart] = formatted.split(", ");
      const [day, month, year] = datePart.split("/");
      return `${day}/${month}/${year} ${timePart}`;
    } catch (error) {
      return "Invalid date";
    }
  };

  useEffect(() => {
    if (!userId) {
      setEmailHistory([]);
      return;
    }

    const fetchEmailHistory = async () => {
      try {
        const response = await axios.get(
          `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/get-email-history/${userId}`,
        );
        const history = response.data || [];
        setEmailHistory(
          history.map((record: EmailHistoryRecord) => ({
            remark: record.remark || "No remakrs available",
            createdDate: record.createdDate
              ? formatDate(record.createdDate)
              : "No date available",
          })),
        );
      } catch (error) {
        setEmailHistory([]);
      }
    };

    fetchEmailHistory();
  }, [userId]);

  return (
    <div className={classes.container}>
      {emailHistory.length === 0 ? (
        <div className={classes.historyPlaceholder}>
          No remark for onboarding details resubmission available
        </div>
      ) : (
        <div className={classes.historyList}>
          {emailHistory.map((record, index) => (
            <div key={index} className={classes.historyItem}>
              <span className={classes.noteText}>{record.remark}</span>
              <p className={classes.dateText}>{record.createdDate}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailContentHistory;
